import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "./LanguageContext"; 
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../styles/LanguageSelector.css";

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Detect mobile based on screen width
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    // Close dropdown if user taps outside (for mobile)
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
      document.addEventListener("touchstart", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <div
      className="language-selector-container"
      ref={containerRef}
      onMouseEnter={() => setIsOpen(true)}  // Works for desktop
      onMouseLeave={() => setIsOpen(false)} // Works for desktop
      onTouchStart={() => setIsOpen(true)}  // Works for mobile
    >
      
<button className="dropdown-toggle">
 {language === "en" ? "English (UK)" : "हिन्दी"}
 </button>

      {isOpen && (
        <ul className="dropdown-menu">
          <li onClick={() => changeLanguage("en")}>English (UK)</li>
          <li onClick={() => changeLanguage("hi")}>हिन्दी</li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
